import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, CanActivate, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { LoginService } from '../login/login.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(private loginService: LoginService, private router: Router) {}

  canActivate(
      next: ActivatedRouteSnapshot,
      state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
      if (this.loginService.isAuthenticated()) {
        if (this.isTokenExpirado()) {
          this.loginService.logout();
          this.router.navigate(['/pages/login']);
          return false;
        }
        return true;
      }
      this.loginService.logout();
        this.router.navigate(['/pages/login']);
        return false;
    }
    isTokenExpirado(): boolean {
      const token = this.loginService.token;
      const payload = this.loginService.obtenerDatosToken(token);
      const now = new Date().getTime() / 1000;
      if (payload.exp < now) {
        return true;
      }
      return false;
    }

}
